.vc-platform-indicator {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    vertical-align: top;
    position: relative;
}
